import React, {Component} from 'react';
import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import cn                 from 'classnames'

const isAbsoluteURL = new RegExp('^(?:[a-z]+:)?//', 'i');

const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: (node, next) => {
        // Get the image URL from the node
        const imageUrl = node.data.target.fields.file.url;
        
        // Check if it's a Contentful image
        const isContentfulImage = imageUrl.includes('images.ctfassets.net');
        
        // Build the proxy URL - handle both protocol-relative and absolute URLs
        let cleanUrl = imageUrl;
        if (imageUrl.startsWith('//')) {
          cleanUrl = imageUrl.replace('//', '');
        } else if (imageUrl.startsWith('https://')) {
          cleanUrl = imageUrl.replace('https://', '');
        } else if (imageUrl.startsWith('http://')) {
          cleanUrl = imageUrl.replace('http://', '');
        }
        
        // Remove the domain if present
        cleanUrl = cleanUrl.replace('images.ctfassets.net/', '');
        
        const proxyUrl = isContentfulImage ? `/api/contentful-image/${cleanUrl}` : imageUrl;
        return `<img style="width: 100%;" src="${proxyUrl}" loading="lazy"/>`;
      },
      [INLINES.HYPERLINK]: (node, next) => {
          const target =  isAbsoluteURL.test(node.data.uri) ? '_blank' : ''
          return `<a href="${node.data.uri}" target="${target}" >${next(node.content)}</a>`;
      }
    }
}

export default class Description extends Component {

    render(){
        const { className, simpleHTML, richHTML, hideHeader } = this.props

        return (
            <div className={cn("tab-description", {"tab-description--hideHeader": hideHeader, [className]: className})}>
                {!hideHeader && <div className="header">Description:</div>}
                <div className="content" dangerouslySetInnerHTML={{__html: simpleHTML ? simpleHTML : documentToHtmlString(richHTML, options)}} />
            </div>
        )
    }
}
